module.exports = __webpack_public_path__ + "img/xrc1.5b7215ae.png";